
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";



const CrucigramaPalabrasForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos,posicionCombo
                              })=>{
	return (
        <>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                                         
        
                            <Form.Field  required  error={errors.posicion}>
                                      <label  >{strings?strings["posicion"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["posicion"]:""} 
                                            name="posicion"
                                             fluid 
                                            search 
                                            selection
                                            onChange={onChange}
                                            value={datos.posicion}
                                            options={posicionCombo}/>
                                    </Form.Field>
        
                            <Form.Field  required  error={errors.num}>            
                              <label  >{strings?strings["num"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["num"]:""} 
                                    name="num"
                                    onChange={onChange}
                                    value={datos.num}
                                    icon='edit'/>
                            </Form.Field>
        
                            
                            <Form.Field  required  error={errors.clue}>            
                              <label  >{strings?strings["clue"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["clue"]:""} 
                                    name="clue"
                                    onChange={onChange}
                                    value={datos.clue}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.answer}>            
                              <label  >{strings?strings["answer"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["answer"]:""} 
                                    name="answer"
                                    onChange={onChange}
                                    value={datos.answer}
                                    icon='edit'/>
                            </Form.Field>
                                            
                          
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/crucigramas">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
               
            </Grid>
        
            
        
       
        
      
        
        </>
	);
};



export default CrucigramaPalabrasForm;